import { HoldingUserPermissions, UserPermissions } from "../types"

type SprayPlansPermissions = UserPermissions["sprayPlans"]

export function mergeHoldingSprayPlansPermissions(user: SprayPlansPermissions, holding: HoldingUserPermissions["hub"]["sprayPlans"]): SprayPlansPermissions {

    if (!holding) {
        return user
    }

    // If "haloAudit" is false, then in effect audits will be disabled
    // This needs to be reflected in "auditPlans.audit", as this impacts the Spray plans module
    const audit = holding.haloAudit

    if (audit) {
        return user
    }

    return {
        ...user,
        auditPlans: {
            audit: false
        }
    }

}
